<script setup lang="ts">
import SectionCard from 'pejer/src/components/ui/section-card/SectionCard.vue'
import { Comment, Fragment, Text, computed, useSlots } from 'vue'
import { cn } from '../lib/utils'
const props = defineProps<{
  header: string
  showFallback?: boolean
  class?: string
  isSensitive?: boolean
}>()

const slots = useSlots()

function vNodeIsEmpty(vnodes: any[]) {
  return vnodes.every((node) => {
    if (node.type === Comment) return true
    if (node.type === Text && !node.children?.trim()) return true
    if (node.type === Fragment && vNodeIsEmpty(node.children)) {
      return true
    }

    return false
  })
}

const isEmpty = (slot: any) => {
  if (!slot) return true

  return vNodeIsEmpty(slot())
}
const slotIsEmpty = computed(() => {
  return isEmpty(slots.default)
})
</script>
<template>
  <SectionCard :class="cn('rounded-md p-2  border py-2 px-3', props.class)">
    <h2 class="flex gap-4 font-semibold items-center text-sm text-slate-700">
      {{ header }} <span class="ml-auto"><slot name="icon"></slot></span>
    </h2>
    <h3
      :class="
        cn('text-sm flex justify-start font-normal items-center', isSensitive ? 'sentry-mask' : '')
      "
    >
      <span v-if="slotIsEmpty || showFallback" class="text-red-400 flex items-center gap-2">
        <span class="text-gray-400 text-sm">No value</span>
      </span>
      <slot v-else></slot>
    </h3>
    <!-- <Separator /> -->
  </SectionCard>
</template>
